import React from 'react';
import styles from './ToClose.module.css';

const ToClose = ({ onClose }) => {
  return (
    <div className={styles.toCloseContainer} onClick={onClose}>
      <div className={styles.circle}>×</div>
      <span className={styles.label}>Close</span>
    </div>
  );
};

export default ToClose;
